var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C98A2E"
    },
    d: "M181.437,384.081c-33.195,19.391-58.155,51.332-68.39,89.314 c40.653,23.757,87.738,37.704,138.017,38.563l4.935,0.042l59.219-61.687l-64.154-66.232H181.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD712C"
    },
    d: "M330.561,384.081h-74.562V512c52.131,0,100.971-14.072,142.952-38.605 C388.716,435.413,363.756,403.472,330.561,384.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#915729"
    },
    d: "M320.732,383.447l-19.495-19.495h-45.237l-38.246,61.687l38.246,74.024l49.654-49.653 c5.889-5.889,5.889-15.436,0-21.325l-4.417-4.417l19.495-19.495C326.621,398.883,326.621,389.335,320.732,383.447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD712C"
    },
    d: "M210.762,363.951l-19.495,19.495c-5.889,5.889-5.889,15.436,0,21.325l19.495,19.495l-4.417,4.417 c-5.889,5.889-5.889,15.436,0,21.325l49.654,49.653V363.951H210.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB5034"
    },
    d: "M153.62,405.082c-19.194,18.386-33.451,41.884-40.573,68.313 c10.903,6.371,22.271,12.03,34.038,16.927l29.955-56.38C170.459,423.353,162.577,413.662,153.62,405.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8D472E"
    },
    d: "M367.035,414.099c-2.759-3.126-5.647-6.134-8.657-9.017c-8.957,8.579-16.839,18.272-23.42,28.858 l29.956,56.38c0.708-0.295,1.416-0.59,2.121-0.891c11.011-4.689,21.669-10.049,31.915-16.036 C392.946,451.111,381.867,430.91,367.035,414.099z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#915729"
    },
    d: "M334.958,500.854c10.235-2.961,20.232-6.486,29.956-10.532c-4.306-21.748-14.96-41.214-29.956-56.38 V500.854z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5A150"
    },
    d: "M147.084,490.322c9.724,4.048,19.72,7.571,29.956,10.532v-66.913 C162.045,449.107,151.391,468.572,147.084,490.322z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D5A150"
    },
    points: "206.65,388.9 255.862,437.975 305.349,388.626  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D5A150"
    },
    d: "M502.709,226.204c-1.007-28.166-23.452-51.407-51.57-53.347c-10.5-0.724-20.418,1.495-29.046,5.885 c-9.007-34.075-26.751-66.565-50.442-92.37c-30.618-33.347-71.169-55.529-115.652-55.529c-72.841,0-135.145,59.477-160.535,130.07 c-2.112,5.871-3.97,11.818-5.556,17.815l4.557,139.827c4.625,18.854,10.72,34.849,18.358,42.237 c28.134,27.214,95.264,40.172,143.476,40.172s114.74-12.958,142.874-40.172c12.693-12.277,21.13-48.309,25.63-81.765 c6.86,3.034,14.442,4.731,22.424,4.731C478.566,283.759,503.839,257.795,502.709,226.204z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1B872"
    },
    d: "M338.34,145.53c-4.734-4.659-12.271-5.496-18.333-2.043c-10.01,5.7-20.746,10.002-31.872,12.844 c-10.456,2.671-21.256,4.054-32.135,4.054c-22.456,0-44.59-5.843-64.006-16.898c-6.066-3.452-13.603-2.614-18.331,2.039 l-0.666,0.661l-48.779,48.781c-3.092,3.092-6.763,5.319-10.693,6.698c-5.368-9.825-13.618-17.851-23.614-22.936 c-0.001,0.005-0.002,0.01-0.004,0.015c-8.628-4.39-18.546-6.609-29.046-5.885c-28.118,1.939-50.562,25.179-51.57,53.347 c-1.131,31.589,24.142,57.553,55.48,57.553c7.982,0,15.565-1.698,22.424-4.731c1.793,13.323,4.211,27.05,7.272,39.526 c33.037,18.156,85.275,26.892,124.822,26.892c48.212,0,114.74-12.958,142.874-40.172c11.907-11.517,20.07-43.939,24.75-75.528 c2.91-19.648-3.656-39.512-17.741-53.517C354.742,161.884,338.34,145.53,338.34,145.53z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C98A2E"
    },
    cx: 447.228,
    cy: 228.24,
    r: 18.506
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5A150"
    },
    cx: 64.77,
    cy: 228.24,
    r: 18.506
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6D5B4D"
    },
    d: "M129.821,43.18v31.774l-57.334,47.853c-5.242,12.105-7.717,25.219-7.717,38.391v11.524 c9.049,0,17.586,2.179,25.135,6.021l9.781,4.961c3.807,1.932,8.425,1.195,11.444-1.823c0,0,36.585-36.585,48.781-48.781 c0.257-0.257,0.513-0.511,0.77-0.765c10.789-10.62,27.312-12.422,40.469-4.932l54.849-84.222H129.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#827061"
    },
    d: "M129.821,43.18v31.774c-31.892,8.345-48.642,27.838-57.334,47.853 c-0.63,1.455-1.219,2.924-1.768,4.406c-3.095,8.363,1.852,17.671,10.593,19.436c2.305,0.465,4.589,1.028,6.846,1.684 c8.291,2.414,17.237,0.028,23.342-6.077l29.645-29.642c11.468-11.287,26.709-17.476,42.969-17.476 c11.311,0,22.472,3.102,32.156,8.954c0.027-0.006,0.042-0.01,0.069-0.016l39.66-60.896H129.821z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#625143"
    },
    d: "M361.281,22.891c-50.276-21.434-146.792-41.23-221.902,6.671 c-33.026,21.057-9.558,45.392-9.558,45.392l71.328,52.451c16.179,9.211,34.899,14.474,54.849,14.474s38.67-5.263,54.849-14.475 c13.157-7.49,29.68-5.688,40.469,4.932c0.258,0.254,0.514,0.508,0.771,0.765c12.195,12.195,48.781,48.781,48.781,48.781 c3.019,3.019,7.637,3.754,11.444,1.823l9.759-4.951c7.554-3.848,16.098-6.031,25.156-6.031c0-13.27,0-24.108,0-25.693 C447.228,143.173,446.619,59.282,361.281,22.891z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#827061"
    },
    d: "M179.764,10.495c-13.866,4.572-27.443,10.815-40.384,19.067c-1.347,0.859-2.59,1.724-3.754,2.591 l85.532,64.022c10.648,5.692,22.651,8.692,34.841,8.692c12.841,0,25.475-3.329,36.537-9.627c0.676-0.385,1.357-0.758,2.043-1.12 c17.237-9.085,21.868-31.822,8.76-46.238C266.936,7.85,217.22,4.958,179.764,10.495z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M336.192,209.734H299.18c-5.11,0-9.253,4.143-9.253,9.253s4.143,9.253,9.253,9.253 c0,10.22,8.286,18.506,18.506,18.506c10.22,0,18.506-8.286,18.506-18.506c5.11,0,9.253-4.143,9.253-9.253 S341.302,209.734,336.192,209.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M212.818,209.734h-37.012c-5.11,0-9.253,4.143-9.253,9.253s4.143,9.253,9.253,9.253 c0,10.22,8.286,18.506,18.506,18.506s18.506-8.286,18.506-18.506c5.11,0,9.253-4.143,9.253-9.253S217.929,209.734,212.818,209.734z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#474641"
    },
    d: "M274.505,237.494h-37.012c-5.11,0-9.253,4.143-9.253,9.253s4.143,9.253,9.253,9.253h37.012 c5.111,0,9.253-4.143,9.253-9.253S279.617,237.494,274.505,237.494z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#625143"
    },
    d: "M336.192,172.722H299.18c-5.111,0-9.253,4.143-9.253,9.253c0,5.11,4.142,9.253,9.253,9.253h37.012 c5.111,0,9.253-4.143,9.253-9.253C345.445,176.865,341.303,172.722,336.192,172.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#625143"
    },
    d: "M212.818,172.722h-37.012c-5.11,0-9.253,4.143-9.253,9.253c0,5.11,4.143,9.253,9.253,9.253h37.012 c5.11,0,9.253-4.143,9.253-9.253C222.071,176.865,217.929,172.722,212.818,172.722z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.c35c92883cb41e128bade0713ee71d01.svg";
export { ForwardRef as ReactComponent };